import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcShareScreenOn = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g stroke="currentColor" strokeWidth={2} fill="none" fillRule="evenodd">
      <path d="M5 10h19v12H5zM24.382 22l2 4H2.618l2-4h19.764Z" />
      <path d="M9 7.858V5h20v13h-2.89" />
    </g>
  </svg>
);
export default SvgIcShareScreenOn;
